import React, { useState } from 'react';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import {
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import userPrivelges from 'containers/services/security/user-privileges';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import DecisionDialog from 'components/DecisionDialog/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { INPUT_TYPE } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/constant';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { getTransactionInboxes } from 'containers/AppContainer/AppBar/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';

export interface DecisionDocumentDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  decisionOption: any;
  listings: any;
  requestGetNotificationsInboxes: Function;
  selectedDocument: any;
  handleCloseDrawer: any;
  claimNumbers?: any;
}

const DecisionDocumentDialog: React.FC<DecisionDocumentDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [comment, setComment] = useState(null);
  const [claimNumber, setClaimNumber] = useState(null);
  const [docType, setDocType] = useState(null);

  const handleChangeComment = (event: any) => {
    setComment(event.target.value);
  };
  const handleChangeClaimNumber = (event: any) => {
    setClaimNumber(event.target.value);
  };
  const handleChangeDoc = (event: any) => {
    setDocType(event.target.value);
  };
  const renderDecisionInput = (type: string) => {
    switch (type) {
      case INPUT_TYPE.INPUT_CLAIM_NUMBER:
        return (
          <TextField
            onChange={handleChangeClaimNumber}
            name={'claimNumber'}
            value={claimNumber}
            label={translate({ ...messages.claimNumber }, props)}
            className="input"
            fullWidth
          />
        );
      case INPUT_TYPE.LIST_DOC_TYPE:
        return (
          <FormControl className="field">
            <InputLabel>{translate(messages.typeDocument, props)}</InputLabel>
            <Select value={docType} onChange={handleChangeDoc}>
              {get(props.listings, 'documentTypes', []).map((el: any) => (
                <MenuItem value={el.ItemKey} key={el.ItemKey}>
                  {el.ItemDescription}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case INPUT_TYPE.INPUT_COMMENT:
        return (
          <TextField
            onChange={handleChangeComment}
            name={'comment'}
            value={comment}
            label={translate({ ...messages.comment }, props)}
            className="input"
            multiline
            fullWidth
          />
        );
    }
  };

  const successCallBack = () => {
    onClose();
    props.requestGetNotificationsInboxes({
      inboxes: [
        ...userPrivelges.getUserInboxes().map((el: any) => el.managerInboxesId),
      ],
      transactionAreaInboxes: getTransactionInboxes(),
      isPriorityClaimManager: userPrivileges.userHasPrivilege(
        PRIVILEGES.ISPRIORITYCLAIMSMANAGER,
      ),
    });
    props.handleCloseDrawer();
    toast.success(translate(messages.updateDocumentImagingSucess, props));
  };

  const handleValidate = () => {
    props.validateDialog(
      {
        documentId: get(props.selectedDocument, 'DocumentID'),
        documentImagingDecisionId: get(props.decisionOption, 'id'),
        claimNumber: claimNumber,
        comment: comment,
        docType: docType,
        username: currentUserStorage.get().username,
        claimNumbers: props.claimNumbers,
      },
      successCallBack,
    );
  };
  return (
    <DecisionDialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          {renderDecisionInput(get(props.decisionOption, 'typeInput'))}
        </StyledDiv>
      }
      disabled={false}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

DecisionDocumentDialog.defaultProps = {
  open: false,
};

export default injectIntl(DecisionDocumentDialog);
